export default "__VITE_ASSET__CR8e3UQ1__"